module.exports = "form{display:flex;align-items:center}form>input,form datepicker{margin:0px 7px;width:130px}form>i{cursor:pointer}\n"